
  import { Component, Vue, Watch } from 'vue-property-decorator'
  import axios from 'axios'
  import YoutubePlayer from '@/components/tutorial/YoutubePlayer.vue'
  import { removeAccents } from '@/utils/general'

@Component({
    components: { YoutubePlayer },
  })
  export default class HelpPage extends Vue {
  public selectedTab: number = 0;
  public tabs: Array<{ id: string, label: string }> = [
    { id: 'todos', label: 'Todos' },
    { id: 'leads', label: 'Leads' },
    { id: 'tasaciones', label: 'Tasaciones' },
    { id: 'inspección', label: 'Inspección' },
    { id: 'negociación', label: 'Negociación' },
    { id: 'compra', label: 'Compra' },
    { id: 'financiamiento', label: 'Financiamiento' },
    { id: 'habilitación', label: 'Habilitación' },
    { id: 'kpi', label: 'KPIs' },
    { id: 'publicaciones', label: 'Publicaciones' },
    { id: 'consignación', label: 'Consignaciones' },
    { id: 'evaluación', label: 'Evaluaciones' },
    { id: 'reservas', label: 'Reservas' },
    { id: 'venta', label: 'Venta' },
    { id: 'tesorería', label: 'Tesorería' },
    { id: 'stock', label: 'Stock' },
  ];

    public videos: Array<{ title: string, thumbnail?: string, videoId?: string }> = [];
    public searchQuery: string = '';

  public selectTab (tabId: string): void {
    this.selectedTab = this.tabs.findIndex(tab => tab.id === tabId) ?? 0
  }

    public async fetchVideos (): Promise<void> {
      const API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY

      const channelId = 'UCIsdQ1Rthefh61Y2wcZ6etQ'
      const url = `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${channelId}&part=snippet,id&type=video&order=date&maxResults=20`
      try {
        const response = await axios.get(url)
        this.videos = response.data.items.map((item: any) => ({
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails.medium?.url || '',
          videoId: item.id.videoId || '',
        }))
      } catch (error) {
        console.error('Error fetching videos:', error)
      }
    }

    public created (): void {
      const queryTab = this.$route.query.tab as string

      if (queryTab && this.tabs.some(tab => tab.id === queryTab)) {
        this.selectedTab = this.tabs.findIndex(tab => tab.id === queryTab)
      } else {
      console.log(this.$route.query)
      this.selectedTab = 0
      // Update the URL immediately with the default tab
      this.$router.replace({ query: { ...this.$route.query, tab: this.tabs[0].id } }).catch(() => {
      })
    }
    }

    @Watch('searchQuery')
    onSearchQueryChange (newVal: string): void {
      this.fetchVideos()
  }

  @Watch('selectedTab')
  onSelectedTabChange (val: number): void {
    this.fetchVideos()
    if (!val) return
    if (this.$route.query.tab !== this.tabs[val].id) {
      this.$router.replace({ query: { ...this.$route.query, tab: this.tabs[val].id } }).catch(() => {
      })
    }
  }

    get filteredVideos (): Array<{ title: string, thumbnail?: string, videoId?: string }> {
      let vids = this.videos
      if (this.searchQuery) {
        const queryWords = removeAccents(this.searchQuery.toLowerCase()).split(' ').filter(word => word.trim() !== '')
        if (queryWords.length > 0) {
          vids = vids.filter(video => {
            const title = removeAccents(video.title.toLowerCase())
            return queryWords.some(word => title.includes(word))
          })
        }
      } else if (this.tabs[this.selectedTab] && this.tabs[this.selectedTab].id !== 'todos') {
        const tabWords = removeAccents(this.tabs[this.selectedTab].label.toLowerCase()).split(' ').map(word => word.replace(/(?:es|s)$/, '')).filter(word => word.trim() !== '')

        if (tabWords.length) {
          vids = vids.filter(video => {
            const title = removeAccents(video.title.toLowerCase())
            return tabWords.some(word => title.includes(word))
          })
        }
      }
      return vids
  }
  }
